import api from './apiClient';

export const getReports = async () => {
  const response = await api.get('/PowerBi/reports');
  return response.data;
};

export const getReportGroups = async (environment = 'prod') => {
  const response = await api.get(`/PowerBi/report-groups?environment=${environment}`);
  return response.data;
};

export const getEmbedConfig = async (reportId) => {
  const response = await api.get(`/PowerBi/embed-config/${reportId}`);
  return response.data;
};